import type * as BrazeNamespace from '@braze/web-sdk';

export type DefinedBrazeModule = typeof BrazeNamespace;

// A normal import breaks SSR
export const BrazeModule: DefinedBrazeModule | undefined =
	typeof window === 'undefined' ? undefined : require('@braze/web-sdk');
